import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled from '@emotion/styled'

import { PostFrontmatterType, PostItemType } from '~/types/post.types'
import Route from '~/constants/route'

import { imageMapper } from '~/utils/queryUtils'

import { Label } from '../common'

import { ProfileLabel } from '~/styles/styled'
import { ReactiveWrapper } from '~/styles/image'

type Props = PostFrontmatterType & Pick<PostItemType['node'], 'timeToRead'>

const PostHead: React.VFC<Props> = ({ title, date, tags, thumbnail, timeToRead }) => {
  return (
    <Wrapper>
      <h1>{title}</h1>
      <Info>
        <ProfileLabel>@1000peach</ProfileLabel>
        <span>
          {date}&nbsp;&nbsp;-&nbsp;&nbsp;{`☕️ ${timeToRead} min read`}
        </span>
      </Info>

      <TagList>
        {tags.map(tag => (
          <li key={tag}>
            <Link to={`${Route.post}?tag=${tag}`}>
              <Label clickable>{tag}</Label>
            </Link>
          </li>
        ))}
      </TagList>

      <ReactiveWrapper height="53%">
        <div>
          <Thumbnail image={imageMapper(thumbnail)} alt={title} />
        </div>
      </ReactiveWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin: 40px 0;

  h1 {
    color: ${({ theme: { colors } }) => colors.defaultText};
  }
`

const Info = styled.div`
  margin: 15px 0;
  display: flex;
  align-items: center;
  column-gap: 7px;
  font-weight: 300;
  color: #999;

  span:not(${ProfileLabel}) {
    ${({ theme: { typography } }) => typography.body2}
    padding-left: 3px;
  }
`

const Thumbnail = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  border-radius: 10px;
`

const TagList = styled.ul`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  column-gap: 7px;
  justify-content: flex-end;
`

export default PostHead
